import { render } from "./SvgBackground.vue?vue&type=template&id=f9334e3e"
import script from "./SvgBackground.vue?vue&type=script&lang=js"
export * from "./SvgBackground.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/sections/projectGrid/SvgBackground.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f9334e3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f9334e3e', __exports__)) {
    api.reload('f9334e3e', __exports__)
  }
  
  module.hot.accept("./SvgBackground.vue?vue&type=template&id=f9334e3e", () => {
    api.rerender('f9334e3e', render)
  })

}


export default __exports__